import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../_shared/services/loader.service';
import { CommonHttpService } from '../commonHttp.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-referral',
  templateUrl: './referral.component.html',
  styleUrls: ['./referral.component.css']
})
export class ReferralComponent implements OnInit {
  closeResult: string;
  referralEmail: any;
  referralUrl: any = environment.referralUrl;
  baseUrl: any = environment.apiUrl;
  userId: number;
  SuccessAlertHidden : boolean = false;

  constructor(private service: CommonHttpService, private router: Router, private route: ActivatedRoute, private loaderService: LoaderService, private modalService: NgbModal) { }

  ngOnInit() {
	this.userId = Number(localStorage.getItem('customerId'))
	this.referralEmail = '';
  }

  ReferralModelModal(referralContent: any) {
		this.modalService.open(referralContent).result.then((result) => {
			this.closeResult = `Closed with: ${result}`;
		}, (reason) => {
			this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
		});
  }
  
  private getDismissReason(reason: any): string {
		if (reason === ModalDismissReasons.ESC) {
			return 'by pressing ESC';
		} else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
			return 'by clicking on a backdrop';
		} else {
			return `with: ${reason}`;
		}
  }
  
  referFriend(){
	   
		this.loaderService.display(true);
		let sendData = {CustomerMail : this.referralEmail, Subject: "Referred to use NowGrocery", Message: "Hi, <br> Signup to NowGrocery and get daily use products and groceries deliverd at home.<br> <a href='" + this.referralUrl + "signup?referralId=" +  this.userId + "'>Signup to NowGrocery</a>"} 
		this.service.create(this.baseUrl + 'EmailAPI/EmailSend', sendData)
			.subscribe(
			data => {
				setTimeout(() => {(<HTMLElement>document.getElementById("closeReferral")).click();},2000)
				console.log(data)
				this.SuccessAlertHidden = true;
			    setTimeout(() => {this.SuccessAlertHidden = false;},2000)
				this.loaderService.display(false);
			    this.referralEmail = ''
				
			},
			(error) => {
				this.loaderService.display(false);
			});
			
	}
}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/referral/referral.component.ts